var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('btn-back'),_c('el-card',[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('DataBlock',{attrs:{"dataToShow":{
            key: _vm.$t('production_area'),
            value: _vm.productionZones.name}}}),_c('DataBlock',{attrs:{"dataToShow":{
            key: 'Id',
            value: _vm.productionZones.id},"size":'mini'}}),_c('DataBlock',{attrs:{"dataToShow":{
            key: 'Description',
            value: _vm.productionZones.description},"size":'mini'}})],1),_c('el-col',{attrs:{"span":8}},[_c('DataBlock',{attrs:{"dataToShow":{
            key: 'Id du capteur',
            value: _vm.productionZones.beaconId},"size":'mini'}})],1)],1),_c('el-divider'),(_vm.isSuperAdmin)?_c('el-row',[_c('h2',[_vm._v("Node configuration")]),_c('p',[_vm._v(_vm._s(_vm.productionZones))])]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }